// extracted by mini-css-extract-plugin
module.exports = {"section":"Section_section__lbtX3","white":"Section_white__2fn2o","gray":"Section_gray__dCl3h"};